

import { Component, OnInit } from '@angular/core';
import { EmitBo } from './claims.model';
@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.scss']
})
export class ClaimsComponent implements OnInit {
  ClaimsEditList: boolean = false;
  constructor() { }
  ngOnInit(): void {
  }
  isEditClaimsView: EmitBo = {
    isedited: false, claimMasterId: "00000000-0000-0000-0000-000000000000",
 
    tabsChanges: 'ReadyClaims', is87IClaim: false, ClaimsfilterDetails:null,isClaimsViewEnable:false, claimsStatusData:null,
    ReadyColumns:null,ActiveColumns:null,ArchiveColumns:null,groupIds:null,PayorIds:null,masterServiceIds:null,
    selectedGroupName:null,companyIds:null,isClaimAttachment:false
  };
  EmitChildComponent(event: EmitBo) {
    this.ClaimsEditList = event.isedited;
    this.isEditClaimsView = event;
  }
}
